import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import Inbox, { IInboxDispatchProps, IInboxProps } from './Inbox'
import { getUserNotificationsList, getUserNotificationsLoading } from './store/InboxSelectors'
import { getUserNotifications } from './store/InboxActions'

const mapStateToProps = (state: IGlobalState, ownProps: any): IInboxProps => ({
  notificationId: ownProps.match.params.notificationId || null,
  isPush: !!state.router.location.query.isPush,
  userNotifications: getUserNotificationsList(state),
  isLoading: getUserNotificationsLoading(state),
})

const mapDispatchToProps: IInboxDispatchProps = {
  getUserNotifications,
}

export default connect(mapStateToProps, mapDispatchToProps)(Inbox)
